
    /**
     * Node type tree builder
     */
    export class NodeTypesTreeBuilder {

        /**
         * Builds the tree
         */
        drawTree (treeData,
            targetDiv,
            eventObservableObj,
            onActivateHandler,
            nodeDeactivateHandler,
            afterChangeHandler,
            selectionChangedHandler): Fancytree.Fancytree  {

            // Attach the dynatree widget to an existing <div id="tree"> element
            // and pass the tree options as an argument to the dynatree() function:

            // Add an "Economic nodes" tree item for convenience
            const allEconNodes = {
                expanded: true,
                folder: false,
                key: -1,
                title: "(All economic nodes)",
                nodeType: "AbstractConversionData",
                extraClasses: "all-economic-nodes" //For dynatree icon
            };

            const allNodes = {
                expanded: true,
                folder: false,
                key: -1,
                title: "(All nodes)",
                nodeType: "NodeDataBlock",
                extraClasses: "all-nodes" //For dynatree icon
            };

            treeData[0].children.splice(0, 0, allEconNodes);
            treeData[0].children.splice(0, 0, allNodes);

            const options: Fancytree.FancytreeOptions = {
                activate: selectionChangedHandler,
                deactivate: nodeDeactivateHandler,
                //autoFocus: true,
                //persist: true, 
                autoCollapse: false,
                selectMode: 2,  // Fancytree.FancytreeSelectMode.multi,
                source: [treeData[0]],
                click: this.nodeClicked,
                select: selectionChangedHandler

            };

            const treeExists = $(targetDiv).find(".ui-fancytree");
            if (treeExists.length > 0) {
                const tree = $(targetDiv).fancytree("getTree");
                tree.reload([treeData[0]]);
                return tree;
            } else {
                $(targetDiv).fancytree(options);
                return $(targetDiv).fancytree("getTree");
            }

        }


        /**
 * Node clicked event
 */
        private nodeClicked = (event: JQueryEventObject, data: Fancytree.EventData) => {

            // If ctrl-click, this is a selection
            if (event.ctrlKey) {
                data.node.toggleSelected();
                return false;
            }

            // If ctrl-click, also a selection
            // Select from active node to the clicked node
            if (event.shiftKey || event.ctrlKey) {
                const activeNode = data.tree.getActiveNode();
                const activeIndex = data.node.parent.children.indexOf(activeNode);
                const clickedIndex = data.node.parent.children.indexOf(data.node);

                for (let i = Math.min(activeIndex, clickedIndex); i <= Math.max(activeIndex, clickedIndex); i++)
                    data.node.parent.children[i].setSelected(true);

                return false;
            }


                data.tree
                    .visit(theNode => {
                        theNode.setSelected(false);
                    });
                return true;
        }

    }



// WEBPACK FOOTER //
// ./ClientApp/components/edit-node-data-dialog/ah.mb.ui.node-types-tree.ts